<template>
  <TitlePlanetHorror title="404 Not found" :catalogo="true"></TitlePlanetHorror>
</template>

<script>
  import TitlePlanetHorror from '@/components/TitlePlanetHorror'
  export default {
    components: { TitlePlanetHorror }
  }
</script>